import React from "react";
import { createRoot } from "react-dom/client";
import "./css/index.css";
import App from "./App";

import { storyblokInit, apiPlugin } from "@storyblok/react";

import BlogPost from "./components/blog/blogpost";
import BlogOverview from "./components/blog/BlogOverview";
import Embed from "./components/blog/embed";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { ErrorElement } from "./components/ErrorElement";

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_TOKEN,
  components: {
    blogpost: BlogPost,
    blogoverview: BlogOverview,
    embed: Embed,
  },
  use: [apiPlugin],
  apiOptions: {
    region: "eu",
  },
});

const router = createBrowserRouter([
  {
    // The old SilverStripe site served the blog under /community, so posts
    // and the overview live there in Storyblok too. Redirect bare "/" there.
    index: true,
    element: <Navigate to="/community" replace />,
  },
  {
    // Category listings, at the same URLs the old SilverStripe blog used.
    // They render the overview story; BlogOverview filters by the param.
    path: "/community/category/:category",
    element: <App storySlug="community" />,
    errorElement: <ErrorElement />,
  },
  {
    path: "/*",
    Component: App,
    errorElement: <ErrorElement />,
  },
]);

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
